var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-people-view" }, [
    _c("div", { staticClass: "c-people-view_container c-view-container" }, [
      _c("div", { staticClass: "c-view-container__inner" }, [
        _c(
          "div",
          { staticClass: "c-people-view_content-col c-view-content-col" },
          [
            _c("h1", { staticClass: "c-people-view__heading" }, [
              _vm._v("Your Home"),
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "c-people-heading" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.PeopleQuestion.PeopleQuestionViewQuestion) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _vm.PeopleQuestion.PeopleQuestionViewNoteText
              ? _c("p", { staticClass: "c-people-view__question-note" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.PeopleQuestion.PeopleQuestionViewNoteText) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("ul", { staticClass: "c-people-fields" }, [
              _c("li", { staticClass: "c-people-field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.peopleQuestion,
                      expression: "peopleQuestion",
                    },
                  ],
                  attrs: { type: "radio", id: "OneTwo", value: "1-2 PEOPLE" },
                  domProps: {
                    checked: _vm._q(_vm.peopleQuestion, "1-2 PEOPLE"),
                  },
                  on: {
                    change: function ($event) {
                      _vm.peopleQuestion = "1-2 PEOPLE"
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "c-people-field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.peopleQuestion,
                      expression: "peopleQuestion",
                    },
                  ],
                  attrs: { type: "radio", id: "Three", value: "3 PEOPLE" },
                  domProps: { checked: _vm._q(_vm.peopleQuestion, "3 PEOPLE") },
                  on: {
                    change: function ($event) {
                      _vm.peopleQuestion = "3 PEOPLE"
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(1),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "c-people-field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.peopleQuestion,
                      expression: "peopleQuestion",
                    },
                  ],
                  attrs: { type: "radio", id: "Four", value: "4 PEOPLE" },
                  domProps: { checked: _vm._q(_vm.peopleQuestion, "4 PEOPLE") },
                  on: {
                    change: function ($event) {
                      _vm.peopleQuestion = "4 PEOPLE"
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(2),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "c-people-field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.peopleQuestion,
                      expression: "peopleQuestion",
                    },
                  ],
                  attrs: { type: "radio", id: "FivePlus", value: "5+ PEOPLE" },
                  domProps: {
                    checked: _vm._q(_vm.peopleQuestion, "5+ PEOPLE"),
                  },
                  on: {
                    change: function ($event) {
                      _vm.peopleQuestion = "5+ PEOPLE"
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(3),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-people-view_animation-col c-view-animation-col" },
          [
            _c(
              "div",
              { staticClass: "c-question-view_animation-wrapper" },
              [
                _c("div", { staticClass: "c-question-view_animation-circle" }),
                _vm._v(" "),
                _c("lottie-vue-player", {
                  attrs: {
                    src: _vm.animationsURL + `house_animation.json`,
                    "player-controls": false,
                    loop: true,
                    autoplay: true,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-view-controls__wrapper" }, [
      _c("div", { staticClass: "c-view-controls" }, [
        _c("div", { staticClass: "c-view-controls__inner" }, [
          _c(
            "button",
            {
              staticClass: "u-calc-button u-calc-button--prev",
              on: { click: _vm.backToStart },
            },
            [_c("span"), _vm._v(" "), _c("p", [_vm._v("Previous")])]
          ),
          _vm._v(" "),
          _vm.canNavigateNext
            ? _c(
                "button",
                { staticClass: "u-calc-button", on: { click: _vm.next } },
                [_c("p", [_vm._v("Next")]), _vm._v(" "), _c("span")]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "OneTwo" } }, [
      _c("p", [_vm._v("1-2 people")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: "_resources/app/client/assets/images/2person.svg",
          alt: "person icon",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "Three" } }, [
      _c("p", [_vm._v("3 people")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: "_resources/app/client/assets/images/3person.svg",
          alt: "person icon",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "Four" } }, [
      _c("p", [_vm._v("4 people")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: "_resources/app/client/assets/images/4person.svg",
          alt: "person icon",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "FivePlus" } }, [
      _c("p", [_vm._v("5+ PEOPLE")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: "_resources/app/client/assets/images/5person.svg",
          alt: "person icon",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }